<template>
  <div class="d-flex justify-content-end">
    <EditSideBar
      :questionnaireOptions="questionnaire?.parts"
      :questionnaireId="questionnaireId"
    />
    <div class="body" id="scroll">
      <CContainer fluid class="ps-4">
        <div class="header">
          <div class="d-flex align-items-center">
            <h1>{{ title }}</h1>
          </div>
          <div class="col-7 d-flex align-items-center justify-content-center">
            <button
              @click="deleteQue"
              :disabled="isSubmit"
              class="btn btn-warning col-2 add-user me-3"
            >
              刪除問卷
            </button>
            <button
              target="_blank"
              @click="toPreview"
              :disabled="isSubmit"
              class="btn btn-primary col-3 add-user"
            >
              儲存並預覽
            </button>
            <button
              @click="editQue()"
              :disabled="isSubmit"
              class="btn btn-primary col-3 add-user mx-3"
            >
              儲存問卷
            </button>
            <button
              :disabled="isSubmit"
              @click="createQue()"
              class="btn btn-primary col-3 add-user"
            >
              發布問卷
            </button>
          </div>
        </div>
        <div class="d-flex edit-questionnaire-wrapper position-relative">
          <div class="col-8 pe-4 ps-1 min-hight scroll-wrapper" ref="questionnaireWrapper">
            <div
              class="d-flex justify-content-end align-items-center px-4 mode-wrapper"
            >
              <p
                v-if="list.length"
                class="mode"
                :class="{ isMode: sortMode }"
                @click="setSortMode"
              >
                {{ sortMode ? '編輯模式' : '排序模式' }}
              </p>
            </div>
            <Questionnaire
              class="drag-min-hight"
              :list="list"
              :sortMode="sortMode"
              :questionnaireWrapper="questionnaireWrapper"
              @cloneList="moveNest"
              @newList="addNewList"
              @deleteItem="deletePartItem($event)"
              @copyItem="copyPartItem($event)"
            />
          </div>
          <div
            class="question-toolbox overflow-scroll"
            v-if="$route.params.part"
          >
            <p class="fw-bold my-2 opacity-75 fs-5">選擇題型</p>
            <Draggable
              :sort="false"
              class="d-flex align-items-center justify-content-center flex-wrap"
              :list="questionTypeList"
              :group="{ name: 'question', pull: 'clone', put: false }"
              :item-key="getId"
              :clone="cloneList"
              @end="setNewCloneClass"
            >
              <template #item="{ element }">
                <button
                  class="position-relative btn-outline-primary btn questionType-btn d-flex align-items-center justify-content-start col-12 mb-3"
                  @click="addQuestionType(element.initValue)"
                >
                  <div class="position-absolute btn-img">
                    <img
                      :src="require(`@/assets/icons/${element.img}.svg`)"
                      alt=""
                    />
                  </div>
                  {{ element.value }}
                </button>
              </template>
            </Draggable>
          </div>
        </div>
      </CContainer>
    </div>
    <MsgBox
      :show="showMsgBox"
      :errorCode="errorCode"
      :errorMsg="errorMsg"
      :confirmText="confirmText"
      @close="showMsgBox = false"
    />
  </div>
</template>
<script>
import MsgBox from '@/components/MsgBox.vue'
import useQuestionnaire from '@/composables/useQuestionnaire'
import Questionnaire from '@/components/Questionnaire.vue'
import Draggable from 'vuedraggable'
import { ref } from '@vue/reactivity'
import EditSideBar from '@/components/EditSideBar.vue'
import { onBeforeRouteLeave, onBeforeRouteUpdate, useRoute } from 'vue-router'
import { manualToggleLoading } from '@/plugins/LoadingSpinner'
import router from '@/router'
import MessageBox from '@/plugins/MessageBox'
import { computed, nextTick } from '@vue/runtime-core'
import {
  ItemTypes,
  SAVE_ACTION_CREATE,
  SAVE_ACTION_NONE,
  SAVE_ACTION_DELETE,
  SAVE_ACTION_UPDATE,
  Part_Is_Display_Yes,
  Item_Require_False,
} from '@/defines'
export default {
  components: {
    EditSideBar,
    Questionnaire,
    Draggable,
    MsgBox,
  },
  setup() {
    const {
      publishQuestionnaire,
      deleteQuestionnaire,
      getQuestionnaire,
      questionnairePartInfo,
      questionnairePartItemsEdit,
    } = useQuestionnaire()
    const questionnaireId = ref('')
    const title = ref('')
    const showMsgBox = ref(false)
    const errorMsg = ref('')
    const errorCode = ref('')
    const editTitle = ref(false)
    const questionnaire = ref([])
    const deleteList = ref([])
    const route = useRoute()
    const sortMode = ref(false)
    const isDelete = ref(false)
    const isSubmit = ref(false)
    const confirmText = ref('確定')
    const setTitle = () => {
      localStorage.setItem('title', title.value)
    }
    const questionTypeList = ref([
      {
        img: 'text',
        value: '單行文字',
        name: 'Input',
        type: ItemTypes.TextItem,
        initValue: {
          title: '',
          type: 'TextItem',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: [],
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'radio',
        value: '單選題',
        name: 'Radio',
        type: ItemTypes.ChoiceOne,
        initValue: {
          title: '',
          type: 'ChoiceOne',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            values: [''],
            last: '',
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'nest',
        value: '量表題',
        name: 'Nest',
        type: ItemTypes.Scale,
        initValue: {
          title: '',
          type: 'Scale',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            rows: [{ title: '第一題' }],
            cols: [{ title: '欄位1', type: '1' }],
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'range',
        value: '數字滑桿',
        name: 'RangeBar',
        type: ItemTypes.NumberSlider,
        initValue: {
          title: '',
          type: 'NumberSlider',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            min: 0,
            max: 100,
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'textarea',
        value: '多行文字',
        name: 'Textarea',
        type: ItemTypes.TextLong,
        initValue: {
          title: '',
          type: 'TextLong',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: [],
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'checkbox',
        value: '多選題',
        name: 'CheckBox',
        type: ItemTypes.ChoiceMultiple,
        initValue: {
          title: '',
          type: 'ChoiceMultiple',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            values: [''],
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'number',
        value: '數字題',
        name: 'NumberInput',
        type: ItemTypes.NumberInput,
        initValue: {
          title: '',
          type: 'NumberInput',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: [],
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'upload-white',
        value: '檔案上傳',
        name: 'File',
        type: ItemTypes.UploadFile,
        initValue: {
          title: '',
          type: 'UploadFile',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: [],
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'stars',
        value: '星級評分',
        name: 'Star',
        type: ItemTypes.Score,
        initValue: {
          title: '',
          type: 'Score',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            type: '1',
            level: '5',
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'sort',
        value: '項目排序',
        name: 'ItemSort',
        type: ItemTypes.ItemSort,
        initValue: {
          title: '',
          type: 'ItemSort',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            items: ['項目1'],
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'date',
        value: '日期',
        name: 'Date',
        type: ItemTypes.DateInput,
        initValue: {
          title: '',
          type: 'DateInput',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            type: '1',
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'form',
        value: '表單題',
        name: 'Form',
        type: ItemTypes.ColumnInput,
        initValue: {
          title: '',
          type: 'ColumnInput',
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            rows: [{ title: '第一題' }],
            cols: [{ title: '欄位1', type: '1' }],
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'form',
        value: '動態表單題',
        name: 'DynamicForm',
        type: ItemTypes.DynamicForm,
        initValue: {
          title: '',
          type: ItemTypes.DynamicForm,
          is_display: Part_Is_Display_Yes,
          image: null,
          required: Item_Require_False,
          description: '',
          extension_info: {
            cols: [{ title: '欄位1', type: '1' }],
          },
          action: SAVE_ACTION_CREATE,
        },
      },
      {
        img: 'introduction',
        value: '引言',
        name: 'CategoryTitle',
        type: ItemTypes.Introduction,
        image: null,
        required: Item_Require_False,
        initValue: {
          title: '',
          type: 'Introduction',
          image: null,
          is_display: Part_Is_Display_Yes,
          required: Item_Require_False,
          description: '',
          extension_info: [],
          action: SAVE_ACTION_CREATE,
        },
      },

      // {
      //   img: 'divider',
      //   value: '分隔線',
      //   type: 'Divider',
      // },
    ])
    const list = ref([])
    const originListStr = ref('[]')
    const questionnaireWrapper = ref(null)
    const getId = (item)=>{
      return JSON.stringify(item)
    }
    onBeforeRouteUpdate(async () => {
      if (hasEdited.value && !isDelete.value) {
        let flag = null
        MessageBox({
          message: '此分類尚未儲存，請先儲存再進行動作避免資料遺失。',
          cancelButtonText: '繼續編輯',
          confirmButtonText: '不保存離開此頁',
          cancelBtnColor: 'primary',
          confirmBtnColor: 'secondary',
          onConfirm: () => {
            flag = false
            sortMode.value = false
            list.value = []
            getQue()
          },
          onCancel: () => {
            flag = true
          },
        })
        let p = new Promise((resolve) => {
          const timer = setInterval(() => {
            if (flag !== null) {
              clearInterval(timer)
              resolve(flag)
            }
          }, 30)
        })
        const saveConfirm = await p
        if (saveConfirm) {
          flag = null
          return false
        } else {
          return true
        }
      } else {
        sortMode.value = false
        list.value = []
        getQue()
      }
    })
    onBeforeRouteLeave(async () => {
      if (hasEdited.value) {
        let flag = null
        MessageBox({
          message: '此分類尚未儲存，請先儲存再進行動作避免資料遺失。',
          cancelButtonText: '不保存離開此頁',
          confirmButtonText: '繼續編輯',
          cancelBtnColor: 'secondary',
          confirmBtnColor: 'primary',
          onConfirm: () => {
            flag = true
          },
          onCancel: () => {
            flag = false
          },
        })
        let p = new Promise((resolve) => {
          const timer = setInterval(() => {
            if (flag !== null) {
              clearInterval(timer)
              resolve(flag)
            }
          }, 30)
        })
        const saveConfirm = await p
        if (saveConfirm) {
          flag = null
          return false
        } else {
          return true
        }
      }
    })
    const deletePartItem = (event) => {
      const isDelete = window.confirm('是否確認刪除')
      const item = event[1]
      if (!isDelete) return
      if (event[1].action !== SAVE_ACTION_CREATE) {
        item.action = SAVE_ACTION_DELETE
        deleteList.value.push(item)
        const index = list.value.findIndex(
          (e) => e.part_item_id === item.part_item_id,
        )
        list.value.splice(index, 1)
      } else {
        const index = list.value.findIndex((e) => e.time === item.time)
        list.value.splice(index, 1)
      }
    }
    const copyPartItem = (event) => {
      const initVal = questionTypeList.value.find(
        (e) => e.type === event[0].type,
      )
      const item = JSON.parse(JSON.stringify(initVal.initValue))
      item.title = event[0].title + ' 複製'
      item.time = new Date().getTime()
      item.random_id = new Date().getTime()*Math.random();
      item.action = SAVE_ACTION_CREATE
      item.description = JSON.parse(JSON.stringify(event[0].description))
      item.extension_info = JSON.parse(JSON.stringify(event[0].extension_info))
      item.image = JSON.parse(JSON.stringify(event[0].image))
      list.value.splice(event[1], 0, item)
    }
    const addQuestionType = async (initValue) => {
      const item = JSON.parse(JSON.stringify(initValue))
      item.time = new Date().getTime()
      item.random_id = new Date().getTime()*Math.random();
      await list.value.push(item)
      questionnaireWrapper.value.scrollTop =
        questionnaireWrapper.value.scrollHeight
    }
    const cloneList = (e) => {
      const item = JSON.parse(JSON.stringify(e.initValue))
      item.time = new Date().getTime()
      item.random_id = new Date().getTime()*Math.random();
      return item
    }
    const addNewList = (e) => {
      if (e.part_item_id) {
        const findId = list.value?.findIndex(
          (item) => item.part_item_id === e.part_item_id,
          )
          if (findId === -1) {
            list.value.push(e)
          } else {
            list.value.splice(findId, 1, e)
          }
        } else {
          e.action = SAVE_ACTION_CREATE
          const findId = list.value?.findIndex((item) => item.time === e.time)
          list.value.splice(findId, 1, e)
        }
    }
    const setNewCloneClass = () => {
      const items = document.querySelectorAll('.type-wrapper')
      items.forEach((e) => {
        if (sortMode.value) {
          e.classList.add('isMove')
        } else {
          e.classList.remove('isMove')
        }
      })
    }
    const setSortMode = () => {
      const items = document.querySelectorAll('.type-wrapper')
      items.forEach((e) => {
        if (!sortMode.value) {
          e.classList.add('isMove')
        } else {
          e.classList.remove('isMove')
        }
      })
      sortMode.value = !sortMode.value
    }
    const getQue = async () => {
      manualToggleLoading(true)
      const res = await getQuestionnaire({ id: +route.params.id })
      if (res.error) {
        manualToggleLoading(false)
        confirmText.value = '確定'
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        manualToggleLoading(false)
        questionnaire.value = res.ret.questionnaire
        title.value = questionnaire.value?.title

        questionnaireId.value = questionnaire.value?.id
        const id = route.params.part
        if (!id) {
          router.push(
            `/${questionnaireId.value}/${questionnaire.value?.parts[0].id}`,
          )
          return
        }
        const itemList = await questionnairePartInfo({ id })
        if (itemList.error) {
          return
        }
        list.value = itemList.ret.info.items || []
        list.value.map((e) => {
          e.action = SAVE_ACTION_NONE
          e.random_id = new Date().getTime()*Math.random();
        })
        originListStr.value = JSON.stringify(itemList.ret.info.items || [])
      }
    }
    const hasEdited = computed(() => {
      for (const item of list.value) {
          if(item.action != SAVE_ACTION_NONE){
            return true;
          }
      }
      if(deleteList.value.length>0){
        return true;
      }
    })
    // const beforeUnloadListener = (event) => {
    //   if (hasEdited.value) {
    //     event.preventDefault()
    //     return (event.returnValue = 'Are you sure you want to exit?')
    //   }
    // }
    // onBeforeUnmount(() => {
    //   window.removeEventListener('beforeunload', beforeUnloadListener, {
    //     capture: true,
    //   })
    // })
    // window.addEventListener('beforeunload', beforeUnloadListener, {
    //   capture: true,
    // })
    getQue()
    const listToString = computed(() => {
      return JSON.stringify(list.value)
    })

    const createQue = async () => {
      const isEdit = list.value.filter(
        (e) =>
          e.action === SAVE_ACTION_CREATE || e.action === SAVE_ACTION_UPDATE,
      )
      if (isEdit.length) await editQue()
      const res = await publishQuestionnaire({
        id: questionnaireId.value,
        type: '1',
      })
      if (res.error) {
        confirmText.value = '確定'
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = 'publishError'
      } else {
        MessageBox({
          message: '發布成功',
          onConfirm: () => {
            router.push('/analysis-questionnaire')
          },
        })
      }
    }

    const toPreview = async () => {
      if(isSubmit.value){
        location.reload()
      }
      const res = await questionnairePartItemsEdit({
        id: route.params.part,
        title: title.value,
        part_items: [...list.value, ...deleteList.value],
      })
      if (res.error) {
        confirmText.value= '確定'
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        isSubmit.value = true
        deleteList.value = []
        const display_part = questionnaire.value?.parts.filter(
          (e) => e.is_display === Part_Is_Display_Yes,
        )
        if (!display_part.length) {
          confirmText.value = '確定'
          showMsgBox.value = true
          errorMsg.value = '沒有可預覽的題目'
          return
        }
        await getQue()
        const routeData = router.resolve({
          path: `/preview/${questionnaire.value?.id}/${display_part[0].id}`,
        })
        window.open(routeData.href, '_blank')
        location.reload()
      }
    }
    const editQue = async () => {
      if(isSubmit.value){
        location.reload()
      }
      const res = await questionnairePartItemsEdit({
        id: route.params.part,
        title: title.value,
        part_items: [...list.value, ...deleteList.value],
      })
      if (res.error) {
        confirmText.value = '確定'
        showMsgBox.value = true
        errorMsg.value = res.msg
        errorCode.value = res.error
      } else {
        deleteList.value = []
        isSubmit.value = true
        confirmText.value = '編輯中'
        showMsgBox.value = true
        errorMsg.value = '編輯並儲存完成'
        // window.removeEventListener('beforeunload', beforeUnloadListener, {
        //   capture: true,
        // })
        nextTick(async () => {
          await getQue()
          location.reload()
        })
      }
    }

    const deleteQue = async () => {
      if (!confirm('是否確定刪除該問卷')) {
        return false
      }
      if (questionnaireId.value) {
        await deleteQuestionnaire({ id: questionnaireId.value })
        title.value = ''
        questionnaireId.value = ''
        list.value = []
        router.push('/analysis-questionnaire')
        isDelete.value = true
      }
    }
    const moveNest = ($event) => {
      list.value = $event
    }

    const displayIndexMap = computed(() =>
      list.value
        .filter((item) => item.type !== '4' && item.type !== '14')
        .reduce((accu, cur, i) => {
          accu[cur.id] = i + 1
          return accu
        }, {}),
    )
    return {
      questionTypeList,
      list,
      questionnaireWrapper,
      addQuestionType,
      addNewList,
      cloneList,
      setNewCloneClass,
      title,
      editTitle,
      createQue,
      editQue,
      deleteQue,
      getQue,
      questionnaireId,
      errorCode,
      setTitle,
      showMsgBox,
      errorMsg,
      toPreview,
      questionnaire,
      moveNest,
      listToString,
      hasEdited,
      originListStr,
      displayIndexMap,
      deleteList,
      deletePartItem,
      copyPartItem,
      sortMode,
      setSortMode,
      isSubmit,
      getId,
      confirmText
    }
  },
}
</script>
<style lang="scss" scoped>
.header {
  padding: 40px 20px;
  width: calc(100vw - 255px);
  right: 0;
  position: fixed;
  top: 0;
  z-index: 1;
}

.body {
  width: calc(100vw - 255px);
}

h1 {
  font-family: 'Noto Sans';
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 33px;
}

.title {
  width: 100%;
  border: 0;
  outline: none;
}
.questionType-btn {
  border: dashed 1px #9ca0a8;
  padding: 0 91px;
  height: 48px;
  border-radius: 3px;
}
.btn-img {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #177baf;
  border-radius: 3px;
  left: -2px;
}
.edit-questionnaire-wrapper {
  padding: 0;
  max-width: 1136px;
  margin: 150px auto;
  @media screen and (min-width: 1200px) {
    max-width: 2000px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
}
.is-published-wrapper {
  width: 100%;
  height: 100%;
  background-color: rgba($color: #fff, $alpha: 0.5);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
  p {
    border: 1px dashed #177baf;
    color: #177baf;
    padding: 10px;
    border-radius: 5px;
  }
}
.que-title {
  border: dashed 1px #9ca0a8;
  padding: 0 10px;
}
.active {
  border: 1px dashed #177baf;
  outline-color: #177baf;
}
.drag-min-hight {
  min-height: 500px;
}
.question-toolbox {
  height: calc(100vh - 150px);
  position: fixed;
  top: 150px;
  right: 1.5rem;
  width: calc(33.3% - 7.5rem);
}
.mode-wrapper {
  margin: 0 0 -20px 0;
}
.mode {
  color: #177baf;
  font-weight: 600;
  padding: 5px 10px;
  cursor: pointer;
  &:hover {
    color: #53aede;
  }
}
.isMode {
  background: #177baf;
  color: #fff;
  cursor: pointer;
  padding: 5px 10px;
  border-radius: 8px;
  &:hover {
    background: #53aede;
    color: #fff;
  }
}
</style>
